import type { ReactText } from 'react';
import DOMPurify from 'dompurify';
import _escape from 'lodash/escape';
import type { CellContext, RowData } from '@tanstack/react-table';

type THighlightableCellProps<TData extends RowData, TValue = unknown> = Pick<
  CellContext<TData, TValue>,
  'table'
> & { children: ReactText | null };

const HighlightableCell = <TData extends RowData, TValue = unknown>({
  table,
  children,
}: THighlightableCellProps<TData, TValue>) => {
  children =
    typeof children === 'string' || typeof children === 'number'
      ? children.toString()
      : '';
  const { globalFilter: searchTerm } = table.getState();

  if (!searchTerm) return <>{children}</>;

  const searchRegex = new RegExp(`(${_escape(searchTerm)})`, 'ig');
  const highlightedText = children.replace(
    searchRegex,
    '<span class="cell-search-highlight">$1</span>'
  );

  return (
    <div
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highlightedText) }}
    />
  );
};

export default HighlightableCell;
